export default "__VITE_ASSET__0b7Cxmxd__"